import { io } from "socket.io-client";

class NotificationService {
  socket;
  constructor() {}

  setupSocketConnection() {
      this.socket = io(process.env.VUE_APP_NOTIFICATION, {
      query: { userId: localStorage.getItem('userId'), app: "muleex", },
      reconnection: true,          // Enable reconnection
      reconnectionAttempts: 5000,    // Number of reconnection attempts
      reconnectionDelay: 4000,     // Time delay in milliseconds between attempts
      reconnectionDelayMax: 8000,  // Maximum reconnection delay
    });

    // Handle reconnection events
    this.socket.on("connect", () => {
      console.log("notification Socket connected");
    });

    this.socket.on("reconnect", (attemptNumber) => {
      console.log(`Socket reconnected after ${attemptNumber} attempts`);
    });

    this.socket.on("reconnect_error", (error) => {
      console.error("Socket reconnection error:", error);
    });
  }


  connected() {
    this.socket.on("connect", () => {
      console.log("notification socket connection: ", this.socket.connected); // true
    });
  }

  Notifications() {
    return new Promise((resolve, reject) => {
      this.socket.on('Shipment_assigned', (msg) => {
        let response = msg;
        resolve(response); // Resolve the promise with the response
      });

      // Handle any errors
      this.socket.on("error", (error) => {
        reject(error);
      });
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}

export default new NotificationService();
